
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { EnhancedLabel } from '@/lib/shadcn-enhanced';
import InterviewRequestEmailTemplate from '@/components/email/InterviewRequestEmailTemplate';

interface EditPanelProps {
  emailConfig: {
    from: string;
    subject: string;
    intervieweeName: string;
    question: string;
    context: string;
    submissionUrl: string;
    baseUrl: string;
  };
  introText: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setActiveTab: (tab: string) => void;
}

export const EditPanel: React.FC<EditPanelProps> = ({ 
  emailConfig, 
  introText,
  handleChange, 
  setActiveTab 
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <Card className="lg:col-span-2">
        <CardHeader>
          <CardTitle>Rediger mal</CardTitle>
          <CardDescription>
            Endre e-postens innhold og formatering
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <EnhancedLabel htmlFor="from">Fra</EnhancedLabel>
                <Input
                  id="from"
                  name="from"
                  value={emailConfig.from}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <EnhancedLabel htmlFor="subject">Emne</EnhancedLabel>
                <Input
                  id="subject"
                  name="subject"
                  value={emailConfig.subject}
                  onChange={handleChange}
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <EnhancedLabel htmlFor="intervieweeName">Intervjuobjektets navn (eksempel)</EnhancedLabel>
              <Input
                id="intervieweeName"
                name="intervieweeName"
                value={emailConfig.intervieweeName}
                onChange={handleChange}
              />
            </div>
            
            <div className="space-y-2">
              <EnhancedLabel htmlFor="question">Spørsmål (eksempel)</EnhancedLabel>
              <Textarea
                id="question"
                name="question"
                value={emailConfig.question}
                onChange={handleChange}
                rows={3}
              />
            </div>
            
            <div className="space-y-2">
              <EnhancedLabel htmlFor="context">Kontekst (eksempel)</EnhancedLabel>
              <Textarea
                id="context"
                name="context"
                value={emailConfig.context}
                onChange={handleChange}
                rows={3}
              />
            </div>
            
            <div className="space-y-2">
              <EnhancedLabel htmlFor="submissionUrl">URL for innsending (eksempel)</EnhancedLabel>
              <Input
                id="submissionUrl"
                name="submissionUrl"
                value={emailConfig.submissionUrl}
                onChange={handleChange}
              />
            </div>
            
            <div className="space-y-2">
              <EnhancedLabel htmlFor="baseUrl">Base URL for bilder</EnhancedLabel>
              <Input
                id="baseUrl"
                name="baseUrl"
                value={emailConfig.baseUrl}
                onChange={handleChange}
              />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Forhåndsvisning</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-auto bg-slate-50 p-4 rounded-md max-h-[600px]">
            <InterviewRequestEmailTemplate 
              intervieweeName={emailConfig.intervieweeName}
              question={emailConfig.question}
              context={emailConfig.context}
              submissionUrl={emailConfig.submissionUrl}
              baseUrl={emailConfig.baseUrl}
              introText={introText}
            />
          </div>
          <div className="mt-4">
            <Button 
              onClick={() => setActiveTab('preview')} 
              className="w-full"
            >
              Se full forhåndsvisning
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
